"use client";

import { HoverPrefetchLink } from "@/components/ui/hover-prefetch-link";
import { ShoppingCart } from "@/components/icons";
import { Button } from "@/components/ui/button";

export function CartLink({ itemCount }: { itemCount: number }) {
 return (
  <Button
   asChild
   variant="quiet"
   size="icon-compact"
   className="relative w-8 hover:text-action"
  >
   <HoverPrefetchLink
    href="/cart"
    aria-label={`Cart${itemCount ? ` (${itemCount} items)` : ""}`}
   >
    <ShoppingCart className="size-4" />
    {itemCount > 0 && (
     <span className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-action-fill px-1 text-xs font-medium text-action-fill-foreground">
      {itemCount > 99 ? "99+" : itemCount}
     </span>
    )}
   </HoverPrefetchLink>
  </Button>
 );
}
